module.exports = __webpack_public_path__ + "static/media/icon-collection.0b29c9f7.svg";